

export default function About() {
  const credentials = [
    { text: 'MBA in Finance and Management Sciences, California State University, Hayward', icon: 'ri-graduation-cap-fill' },
    { text: 'Risk Management Certificate, University of Cambridge', icon: 'ri-award-fill' },
    { text: 'Nonprofit Financial Stewardship Certificate, Harvard Kennedy School', icon: 'ri-medal-fill' }
  ];

  return (
    <section id="about" className="py-24 bg-white relative overflow-hidden">
      <div className="absolute top-1/2 left-0 w-96 h-96 bg-[#c47a3a]/10 rounded-full blur-3xl -translate-y-1/2 -translate-x-1/2"></div>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
        <div className="text-center mb-16">
          <span className="inline-block text-[#059669] text-sm font-semibold tracking-widest uppercase mb-4">Who We Are</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900" style={{ fontFamily: "'EB Garamond', 'Times New Roman', serif" }}>
            About Butler Professional Services
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-[#c47a3a]/20 to-[#059669]/10 rounded-2xl blur-xl"></div>
              <div className="relative bg-[#612c42]/10 backdrop-blur-sm rounded-2xl p-2 border border-[#612c42]/20">
                <div className="w-full h-[560px] rounded-xl overflow-hidden">
                  <img
                    src="https://static.readdy.ai/image/7f87cd0470b0952245d57f0e6ea3c4d4/affbab386fd90230ee90a11e295d99d2.jpeg"
                    alt="Antonia Mayweather, Owner of Butler Professional Services"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-2xl p-6 border-4 border-[#c47a3a]">
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#612c42]" style={{ fontFamily: "'EB Garamond', serif" }}>Est. 1993</div>
                  <div className="text-sm text-gray-600 font-medium">Serving With Integrity</div>
                </div>
              </div>
              <div className="absolute -top-4 -right-4 bg-[#059669] text-white p-4 rounded-lg shadow-lg">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-shield-star-fill text-2xl"></i>
                </div>
              </div>
            </div>
          </div>

          <div>
            <p className="text-base text-gray-600 leading-relaxed mb-8">
              Since 1993, Butler Professional Services has been known for accuracy, integrity, and responsive service. We combine deep technical knowledge with a straightforward, relationship-focused approach, so you always know where your finances stand.
            </p>

            <div className="bg-gradient-to-br from-warm-50 to-warm-100 p-8 rounded-lg mb-8 border border-warm-200">
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center" style={{ fontFamily: "'EB Garamond', serif" }}>
                <div className="w-8 h-8 flex items-center justify-center bg-[#612c42]/10 rounded-lg mr-3">
                  <i className="ri-award-line text-lg text-[#612c42]"></i>
                </div>
                Credentials
              </h3>
              <ul className="space-y-5">
                {credentials.map((credential, index) => (
                  <li key={index} className="flex items-start">
                    <div className="w-8 h-8 flex items-center justify-center bg-[#059669]/10 rounded-full flex-shrink-0 mt-0.5">
                      <i className={`${credential.icon} text-sm text-[#059669]`}></i>
                    </div>
                    <span className="ml-4 text-sm text-gray-700 leading-relaxed">
                      {credential.text}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="relative bg-[#612c42]/5 border-l-4 border-[#c47a3a] p-6 rounded-r-lg">
              <i className="ri-double-quotes-l text-4xl text-[#612c42]/15 absolute top-2 right-4"></i>
              <p className="text-sm text-gray-800 font-medium italic leading-relaxed relative">
                Our mission is simple: deliver trustworthy financial information so you can focus on growing your organization.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
